export default "__VITE_PUBLIC_ASSET__f00e8ec3__"